import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { STATUS_META, categoryLabel, localizeListing } from "@/pages/nexus/meta";

export default function ListingCard({ listing: raw }) {
  const { t, i18n } = useTranslation();
  const listing = localizeListing(raw, i18n.language);
  const status = STATUS_META[listing.status_badge] || STATUS_META.available;
  return (
    <motion.div whileHover={{ y: -4 }} transition={{ duration: 0.4 }} className="h-full flex flex-col">
      <Link
        to={`/nexus/listings/${listing.slug}`}
        className="nx-card block flex-1"
        data-testid={`listing-card-${listing.slug}`}
      >
        <div className="flex items-start justify-between gap-4 mb-6">
          <span className={`nx-status ${status.cls}`} data-testid={`listing-status-${listing.slug}`}>
            <span className="dot" style={{ background: "currentColor", opacity: 0.85 }} />
            {status.label}
          </span>
          {listing.featured && <span className="nx-tag pewter">Featured</span>}
        </div>

        <h3 className="font-serif text-2xl leading-[1.15] text-[var(--bone)] mb-5 min-h-[3rem]">
          {listing.title}
        </h3>

        <div className="flex flex-wrap gap-2 mb-6">
          <span className="nx-tag">{listing.jurisdiction}</span>
          {listing.regulator && <span className="nx-tag">{listing.regulator}</span>}
        </div>

        <p className="text-[var(--bone-2)] text-sm leading-relaxed mb-6 line-clamp-3">
          {listing.teaser_summary}
        </p>

        <div className="pt-5 border-t border-[var(--line)] flex items-center justify-between">
          <span className="font-mono text-[10px] uppercase tracking-[0.16em] text-[var(--bone-2)]/60">
            {categoryLabel(listing.category)}
          </span>
          <span className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.16em] text-[var(--pewter)]">
            {t("nexus.home.viewAll").split(" ")[0]} <ArrowUpRight size={12} />
          </span>
        </div>
      </Link>
      {/* Advisory + NDA microcopy — sits inside the same grid cell, below the card */}
      <div className="mt-4 space-y-1.5">
        <p className="font-mono text-[10px] uppercase tracking-[0.14em] text-[var(--bone-2)]/55 leading-relaxed">
          {t("nexus.listing.priceUnderNDA")} · {t("nexus.listing.confidentialDetail")}
        </p>
        <p className="text-[11px] text-[var(--bone-2)]/50 leading-relaxed">
          {t("nexus.listing.advisoryLayerDesc").split("—")[0].trim()}.
        </p>
      </div>
    </motion.div>
  );
}
